<script lang="ts" setup>
import { computed } from 'vue';
import type { HomepageWhyJoinAsServiceProvider } from '../../models/homepage';
import useI18NAsync from '~/composables/i18nAsync';
import HomepageServiceProviderFeature from './HomepageServiceProviderFeature.vue';
import { useTranslations } from '~/composables/translations';

const { $i18n } = useTranslations('components/homepage/why_join_service_provider');
const i18nSuspense = useI18NAsync('components/homepage/why_join_service_provider');

const features = computed(
  () =>
    [
      {
        name: $i18n('reach'),
        icon: 'users',
        content: $i18n('reachContent'),
      },
      {
        name: $i18n('promote'),
        icon: 'megaphone',
        content: $i18n('promoteContent'),
      },
      {
        name: $i18n('receive'),
        icon: 'exchange-cog',
        content: $i18n('receiveContent'),
      },
      {
        name: $i18n('develop'),
        icon: 'chart-line-single',
        content: $i18n('developContent'),
      },
      {
        name: $i18n('operate'),
        icon: 'globe',
        content: $i18n('operateContent'),
      },
      {
        name: $i18n('digitize'),
        icon: 'cloud',
        content: $i18n('digitizeContent'),
      },
    ] as HomepageWhyJoinAsServiceProvider[],
);
</script>
<template>
  <div class="why-join-as-service-provider-container px-10px--sm px-30px">
    <div
      class="homepage-max-content-container flex flex-column align-items-center justify-center py-70px grid-gap-60px"
    >
      <h1 class="title">
        <i18nSuspense ikey="title" />
      </h1>
      <div class="grid grid-1-columns--xs grid-2-columns--sm grid-3-columns grid-gap-30px">
        <HomepageServiceProviderFeature
          v-for="feature in features"
          :key="`${feature.name}-journey-feature`"
          :feature="feature"
        />
      </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
.why-join-as-service-provider-container {
  background-color: white;
}
</style>
